const Colors = {
  app: {
    primaryBg: "#1B1B1B", // use for app background
    secondaryBg: "#353535", //use for side bar and search
    primary: "#B87333", // Used as iconDark, textDark, paraTextDark, buttonDark,sidebarTextDark
    darkPrimary: "#04040470",
  },

  background: {
    default: "#1B1B1B", // Used as background
    form: "#3B3B3B", // Used as formBackground, sideBarBg, search
    upload: "#ffffff59", // Used as uploadBackground
    lightBg: "#FFFFFF", // Used as lightBg
    fileUpload: "#FFFFFFA6", // Used as fileUploadBackground
    fileUploadInner: "#FFFFFF4D", // Used as fileUploadInnerBackground
    detailBg: "0px 0px 100px #FFFFFF4D",
    detailLeftBg: "#000", //use for detail page left bg
    detailRightBg: "#ffffff40", //use for detail page right pg
    noDataBg: "rgba(255, 255, 255, 0.1)",
     textAreaBg: "#2F2F2F",
  },
  bannerBox: {
    background: "#ffffff", //use for banner bg
    color: "#ffffff", //use for banner color
  },
  button: {
    dark: "#B87333", // use for dark default btn
    secondary: "#B5883B", //use for signin and login page
    text: "#FFFFFF", // Used as buttonText
    buttonhover: "#B5883B47", // Used as buttonHover
    buttonLoader: "#ffffff", // Used as buttonLoader
    buttonBg: "rgba(255, 255, 255, 0.4)", // Used as buttonBg in some components
    newBtn: "#FFFFFF59",
  },
  text: {
    primary: "#3B3B3B", // Used as textPrimary
    secondary: "#FFFFFF", // Used as textSecondary
    dark: "#B87333", // Used as textDark (same as brand.primary)
    para: "#B87333", // Used as paraTextDark (same as brand.primary)
    secondaryParaText: "#b5883b", //use in commontable
    libraryItems: "#3B3B3B", // Used as libraryItemsText
    inputText: "#b5883b94", // Used as inputText in some place and some place use for banner box
    PlaceHolderText: "#c9a685", //use in mp4 file and creator form
    accent: "#EAE3C9", // Used as creatorSignUp
    loginText: "#b5883b", //login text
    noDataText: "#ff6b6b",
    noResult: "#888",
    loaderText: "#ffffffcc",
    castTag:"#404040",
    castRole: "#868686",
  },
  input: {
    inputText: "#c9a685", //use for input text
    PlaceHolderText: "#B87333",
    inputBg: "#FFFFFF59",
    default: "#B5883B94",
    varientLightText: "#3B3B3B",
    lightBg: "#ffffff",
    pillCategoriesText: "#B5883B",
    detailePage: "#3B3B3B",
    mediaURl: "#b1b1b159",
  },
  icon: {
    dark: "#B87333", // Used as iconDark (same as brand.primary)
    light: "#FFFFFF", // Used as iconLight
    user: "#FFFFFF", // Used as userIcon
    userIconBg: "#B5883B59", //use in creator list
    boxShadow: "#B5883B66", //use for box shadow in creator list user icon
    noData: "#b5883b",
    pillSearchIcon: "#B5883B",
    cameraIconBg: "#eae3c9",
  },

  feedback: {
    error: "#FF3B30",
    warning: "#FF9500",
    success: "#4CD964",
  },
  loader: {
    color: "#333",
    dark: "#b87333",
    loaderBorder: "lightgray",
    background: " rgba(0, 0, 0, 0.4)",
  },
  active: {
    color: "#b5883b47",
  },
  border: {
    newButtonBorder: "#EAE3C9",
    color: "#eae3c9",
    noDataBorder: "rgba(255, 255, 255, 0.2)",
    dark: "#B87333",
    transparent: "transparent",
    light: "#ffffff", // Used as borderLight
    edit:"#292929",
  },
  table: {
    primary: "#3B3B3B",
    secondaryText: "",
  },
  chips: {
    Movie: "#7A33B8",
    "Short Clip": "#33AFB8",
    Podcast: "#B8B633",
    Series: "#B833B8",
    "Live Channel": "#85951D",
    "Live Stream": "#85951D",
    text: "#EAE3C9",
  },
  QC_Status: {
    Rejected: "#442A12",
    Approved: "#65DEFF",
    Pending: "#DBBC0A",
  },
  // NOTE: previously this object was declared twice in this file. The second
  // declaration silently overrode the first, leaving the editorial statuses
  // (Approved/Rejected/N/A/Pending Review/Save Draft) undefined at runtime —
  // so --status-* CSS vars emitted nothing. Both sets are now merged here.
  status: {
    "Pending Review": "#B87333",
    "Save Draft": "#B87333",
    Approved: "#33B86F",
    Rejected: "#B84533",
    "N/A": "#B5A597",
    queued: "#33AFB8",
    processing: "#B87333",
    completed: "#33B86F",
    failed: "#B84533",
  },
  modal: {
    overlayBg: "#3b3b3b57",
    modalBg: "#ffffff4d",
    pillCategorieModalBg: "#FFFFFF8A",
  },
  search: {
    dropdownHover: "#ead8be",
    dropdownBg: "#f4ece3",
    border: "#eee",
  },
  tab: {
    color: "#3b3b3b",
    activeBg: "#ffffff59",
    innerBoxBg: "#FFFFFFA6",
    innerBoxText: "#b5883b94",
  },
  toast: {
    success: "#B8B633",
    error: "#B83333",
    info: "#17a2b8 ",
    warning: "#ffc107",
    warningColor: "#000",
  },
  skeleton: {
    background: "#ffffff59",
    btnBg: "#F4EFE6AD",
    btnText: "#B5883B59",
    saveDraft: "#F4EFE6",
  },
  progressBar: {
    background: "#FFFFFF59",
    progressColor: "#FFFFFF",
    textColor: "#000",
  },

  // ─────────────────────────────────────────────────────────────────────────
  // Design-system scales (Phase 0 — UI modernization).
  // Additive only: existing tokens above are untouched. New components
  // (ListView, redesigned sidebar) consume these instead of hardcoding values.
  // ─────────────────────────────────────────────────────────────────────────

  // Surfaces / elevation — layered on top of the near-black app background.
  // Replaces the scattered "#FFFFFF59 / rgba(255,255,255,0.1)" literals.
  surface: {
    base: "#141414", // page background
    raised: "#1D1D1D", // cards, stat tiles
    raisedHover: "#242424", // card hover
    sunken: "#0F0F0F", // sidebar, wells
    border: "rgba(255, 255, 255, 0.06)", // hairline divider
    borderStrong: "rgba(255, 255, 255, 0.12)", // emphasized / hover border
  },

  // Bronze brand ramp — the single accent (#B87333) expanded into usable stops
  // for fills, tints, text, and translucent hover/active states.
  accent: {
    base: "#B87333", // brand bronze
    soft: "#C9A685", // lighter bronze (titles, active text)
    bright: "#D9A36A", // high-contrast accent text on dark
    tint: "rgba(184, 115, 51, 0.14)", // active-item / chip background
    tintBorder: "rgba(184, 115, 51, 0.35)", // outline buttons (New)
  },

  // Foreground text scale on dark surfaces.
  fg: {
    primary: "#FFFFFF",
    secondary: "#B1B1B1",
    muted: "#7A7A7A",
    faint: "#5F5F5F", // section labels (CONTENT / MANAGE)
  },

  // Spacing scale (px). Use for gaps, padding, layout rhythm.
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "22px",
    "2xl": "32px",
  },

  // Corner radii.
  radius: {
    sm: "8px",
    md: "10px",
    lg: "14px",
    pill: "20px",
    round: "50%",
  },

  // Typography sizes.
  fontSize: {
    label: "10px", // uppercase section/stat labels
    xs: "11px",
    sm: "13px",
    md: "15px",
    lg: "18px",
    xl: "21px",
    stat: "21px", // stat-tile numbers
    title: "30px", // page headings (legacy parity)
  },

  // Semantic state colors for badges/pills (published, draft, etc.).
  state: {
    success: "#5DCAA5",
    successTint: "rgba(93, 202, 165, 0.16)",
    warning: "#E0B341",
    warningTint: "rgba(224, 179, 65, 0.16)",
    danger: "#E24B4A",
    dangerTint: "rgba(226, 75, 74, 0.16)",
  },
};

export default Colors;


